import React, { createContext, useContext } from 'react';
import SideBar from './SideBar';
import NavBar from './NavBar';
import Breadcrumbs from './Breadcrumbs';

/**
 * Quand vrai, <Layout> devient transparent (rend seulement ses enfants).
 * Permet d'embarquer une page qui s'enveloppe elle-même dans <Layout>
 * (ex. les pages de paramètres) à l'intérieur d'un panneau, sans dupliquer
 * la SideBar / NavBar.
 */
export const LayoutEmbedContext = createContext(false);

export default function Layout({ children, title, breadcrumbs = true }) {
  const embedded = useContext(LayoutEmbedContext);
  if (embedded) return <>{children}</>;

  return (
    <div style={{ display: 'flex', minHeight: 'calc(100vh - var(--cb-banniere-h, 0px))', background: '#f8f9fb' }}>
      <SideBar />
      <div style={{
        flex: 1,
        marginLeft: 'var(--cb-sidebar-w)',
        transition: 'margin-left var(--tr-base)',
        marginTop: 56,
        minHeight: 'calc(100vh - 56px - var(--cb-banniere-h, 0px))',
        minWidth: 0,
        overflow: 'hidden',
      }}>
        <NavBar pageTitle={title} />
        {/* `paddingBottom` lit une VARIABLE CSS, pas une constante : un bouton
            d'export flottant la pose le temps qu'il est monte, pour que la fin du
            tableau ne passe pas sous lui. Une variable et non une classe, parce
            que ce padding est inline et gagnerait contre toute regle de feuille de
            style. Voir `utils/reserveBasPage`. */}
        <main style={{
          padding: '28px 32px',
          paddingBottom: 'var(--cb-reserve-bas, 28px)',
          boxSizing: 'border-box',
          width: '100%',
        }}>
          {breadcrumbs && <Breadcrumbs />}
          {children}
        </main>
      </div>
    </div>
  );
}
